module.exports = __webpack_public_path__ + "site/img/p1.f967a70b.png";